import type { ReactNode } from 'react'
import { X } from 'lucide-react'

export function MobileBottomSheet({
  open,
  title,
  onClose,
  testId,
  children,
}: {
  open: boolean
  title: string
  onClose: () => void
  testId?: string
  children: ReactNode
}) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 lg:hidden" role="dialog" aria-modal="true" data-testid={testId}>
      <button
        type="button"
        className="absolute inset-0 bg-black/40"
        aria-label="Close"
        onClick={onClose}
      />
      <div className="absolute bottom-0 left-0 right-0 flex max-h-[75dvh] flex-col rounded-t-2xl border-t border-border bg-card shadow-xl">
        <div className="flex shrink-0 items-center justify-between border-b border-border px-4 py-3">
          <p className="text-sm font-semibold text-foreground">{title}</p>
          <button
            type="button"
            onClick={onClose}
            className="flex h-11 w-11 items-center justify-center rounded-md text-muted-foreground hover:bg-muted"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto px-3 py-3 pb-[max(1rem,env(safe-area-inset-bottom))]">
          {children}
        </div>
      </div>
    </div>
  )
}

export function SheetOptionButton({
  active,
  label,
  onClick,
  count,
  testId,
}: {
  active: boolean
  label: string
  onClick: () => void
  count?: number
  testId?: string
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`flex min-h-11 w-full items-center justify-between rounded-lg px-3 py-2.5 text-left text-sm transition-colors ${
        active
          ? 'bg-primary/10 font-medium text-primary'
          : 'text-foreground hover:bg-muted/60'
      }`}
    >
      <span>{label}</span>
      {count != null && <span className="text-xs text-muted-foreground">{count}</span>}
    </button>
  )
}
